let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("7KD22")]).then(() => parcelRequire('2Dipt'));